import React from 'react';
import PropTypes from 'prop-types';
import { InlineNotification } from '@veneer/core';
import { useI18n } from '@jarvis/react-portal-addons';
import GenericThemeProvider from '../../shared/GenericThemeProvider';
import Container from './styles';

const WelcomeTouInlineNotification = ({
  hpAppTouUrl, onClose, touUrl,
}) => {
  const { t } = useI18n();

  return (
    <GenericThemeProvider>
      <Container>
        <InlineNotification
          status="information"
          closeButton
          border="outlined"
          onClose={onClose}
          title={t('welcomeTouInlineNotification.title')}
          data-testid="welcome-tou-inline-notification"
          description={(
            <span>
              {t('welcomeTouInlineNotification.description.intro')}
              <a
                href={hpAppTouUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('welcomeTouInlineNotification.description.appTouLinkText')}
              </a>
              {' '}
              {t('welcomeTouInlineNotification.description.and')}
              {' '}
              <a
                href={touUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('welcomeTouInlineNotification.description.controlHubTouLinkText')}
              </a>
              {' '}
              {t('welcomeTouInlineNotification.description.formerName')}
            </span>
          )}
        />
      </Container>
    </GenericThemeProvider>
  );
};

WelcomeTouInlineNotification.propTypes = {
  hpAppTouUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  touUrl: PropTypes.string.isRequired,
};

export default WelcomeTouInlineNotification;
